exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-category-text-menu-list {\n  position: absolute;\n  letter-spacing: 1px; }\n  .fmcy-category-text-menu-list .fmcy-category-header {\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 16px;\n    border-bottom: 1px solid;\n    margin-top: 10px;\n    margin-bottom: 5px;\n    cursor: pointer; }\n  .fmcy-category-text-menu-list .fmcy-sub-category-item {\n    cursor: pointer; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/menu/category-text-menu/category/category.scss
 ** module id = 390
 ** module chunks = 1 27 28 101 113
 **/